import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { IOpeningTimeInfo, OpeningTimesService } from 'libs/shared/src';

export type OpeningHoursDisplayAs = 'default';

@Component({
  selector: 'opening-hours',
  imports: [],
  templateUrl: './opening-hours.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class OpeningHoursComponent {
  // Services
  private readonly openingTimesService = inject(OpeningTimesService);

  // Inputs & Models
  /** Defines which style should be rendered as this component is used by multiple components */
  readonly displayAs = input<OpeningHoursDisplayAs>('default');
  /** The title to show over the opening hours */
  readonly openingHoursTitle = input<string>();
  /** The opening-hour entries to display. */
  readonly openingHours = input<IOpeningTimeInfo[]>();

  // Properties & Signals
  /** Entries enriched with a client-rendered, timezone-aware range string. */
  protected readonly rows = computed(() => {
    return (this.openingHours() ?? []).map((item) => ({
      title: this.openingTimesService.formatDayLabel(item.title),
      formattedRange: this.openingTimesService.formatEntryRangeLocalized(item),
      closed: item.closed
    }));
  });
}
